import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Reveal from '@/components/feature/Reveal';
import { useTranslation } from 'react-i18next';
import ServicesHeader from './components/ServicesHeader';
import ServiceCard, { type Service } from './components/ServiceCard';
import ServicesCTA from './components/ServicesCTA';

interface ServiceText {
  title: string;
  description: string;
  imageAlt: string;
  features: string[];
}

const serviceImages = [
  {
    number: '01',
    image:
      'https://readdy.ai/api/search-image?query=A%20pristine%20modern%20office%20interior%20with%20polished%20light%20wood%20floors%2C%20floor%20to%20ceiling%20windows%2C%20minimalist%20white%20desks%20and%20a%20subtle%20reflection%20on%20a%20freshly%20cleaned%20glass%20wall%2C%20soft%20diffused%20daylight%2C%20muted%20sage%20green%20and%20warm%20neutral%20tones%2C%20editorial%20architectural%20photography%2C%20high%20detail%2C%20clean%20and%20airy%20composition&width=800&height=600&seq=limpia-svc-01&orientation=landscape',
  },
  {
    number: '02',
    image:
      'https://readdy.ai/api/search-image?query=An%20elegant%20modern%20residential%20building%20entrance%20lobby%20with%20a%20sweeping%20staircase%2C%20warm%20wooden%20handrail%2C%20clean%20marble%20floor%2C%20soft%20ambient%20lighting%20and%20a%20small%20green%20plant%2C%20minimalist%20Swiss%20architecture%2C%20warm%20neutral%20palette%2C%20editorial%20interior%20photography%2C%20high%20detail%2C%20calm%20and%20refined%20atmosphere&width=800&height=600&seq=limpia-svc-02&orientation=landscape',
  },
  {
    number: '03',
    image:
      'https://readdy.ai/api/search-image?query=A%20welcoming%20reception%20desk%20in%20an%20elegant%20residential%20building%2C%20warm%20natural%20wood%20counter%2C%20soft%20pendant%20lighting%2C%20neatly%20arranged%20keys%20and%20documents%2C%20a%20subtle%20vase%20of%20white%20flowers%2C%20bright%20minimal%20interior%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail%2C%20professional%20and%20approachable&width=800&height=600&seq=limpia-svc-03&orientation=landscape',
  },
  {
    number: '04',
    image:
      'https://readdy.ai/api/search-image?query=A%20meticulously%20manicured%20green%20lawn%20with%20neatly%20trimmed%20hedges%20and%20a%20clean%20stone%20pathway%20in%20front%20of%20a%20modern%20Swiss%20building%2C%20soft%20morning%20sunlight%2C%20fresh%20vibrant%20greens%20with%20warm%20neutral%20building%20tones%2C%20editorial%20landscape%20photography%2C%20high%20detail%2C%20orderly%20and%20serene%20composition&width=800&height=600&seq=limpia-svc-04&orientation=landscape',
  },
  {
    number: '05',
    image:
      'https://readdy.ai/api/search-image?query=A%20bright%20minimalist%20empty%20room%20after%20renovation%20with%20freshly%20painted%20white%20walls%2C%20polished%20concrete%20floor%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20a%20clean%20ladder%20and%20organized%20cleaning%20equipment%2C%20soft%20neutral%20tones%2C%20editorial%20interior%20photography%2C%20high%20detail%2C%20crisp%20and%20immaculate&width=800&height=600&seq=limpia-svc-05&orientation=landscape',
  },
  {
    number: '06',
    image:
      'https://readdy.ai/api/search-image?query=A%20modern%20Swiss%20office%20building%20facade%20with%20clean%20geometric%20lines%2C%20glass%20and%20stone%20materials%2C%20a%20neatly%20organized%20planning%20desk%20with%20a%20tablet%2C%20documents%20and%20a%20small%20plant%20in%20the%20foreground%2C%20soft%20natural%20light%2C%20warm%20neutral%20palette%2C%20editorial%20architectural%20photography%2C%20high%20detail%2C%20professional%20and%20precise&width=800&height=600&seq=limpia-svc-06&orientation=landscape',
  },
];

export default function Services() {
  const { t } = useTranslation();
  const items = t('servicesPage.items', { returnObjects: true }) as ServiceText[];

  const services: Service[] = items.map((item, i) => ({
    number: serviceImages[i].number,
    image: serviceImages[i].image,
    title: item.title,
    description: item.description,
    imageAlt: item.imageAlt,
    features: item.features,
  }));

  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <ServicesHeader />

        <section className="w-full py-20 md:py-28 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {services.map((service, index) => (
                <Reveal key={service.title} delay={(index % 3) * 100}>
                  <ServiceCard service={service} />
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        <ServicesCTA />
      </main>
      <Footer />
    </>
  );
}